import PaymentMethodService from "../service";
import { router } from "@/router";

export const actions = {
  listPaymentMethods: ({ commit, dispatch }, page) => {
    dispatch("enableLoading");

    PaymentMethodService.list()
      .then(res => {
        dispatch("disableLoading");
        commit("setPaymentMethods", res.data);
      })
      .catch(e => {
        dispatch("disableLoading");
        dispatch("createGlobalMessage", {
          type: "error",
          message: e.response.data.message,
          timeout: 6000
        });
      });
  }
};

export default {};
